import type { PushOfflineOrderResult } from 'api/sync'

/**
 * Detect server responses that mapped this checkout to a different sale
 * (e.g. collapsed duplicate heuristics). Compare local print_sequence to server row.
 */
export function isSuspiciousOfflineSyncRow(
  row: PushOfflineOrderResult | undefined,
  localPrintSequence: number | null | undefined,
): boolean {
  if (!row || (row.status !== 'created' && row.status !== 'duplicate')) {
    return false
  }
  if (localPrintSequence == null || row.print_sequence == null) {
    return false
  }

  return Number(row.print_sequence) !== Number(localPrintSequence)
}
